import { useCallback, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import { useDropzone } from "react-dropzone";

export const FileUploaderComp = ({
  bodyText,
  LabelText,
  labelClassName,
  onChange,
  errors,
  required,
  accept = "image/*",
}) => {
  const [loading, setLoading] = useState();
  const onDrop = useCallback((acceptedFiles) => {
    HandlePicture(acceptedFiles[0]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dropzoneAccept =
    accept === "image/*"
      ? { "image/*": [".jpeg", ".jpg", ".png", ".gif", ".bmp", ".webp"] }
      : accept === "documents" || accept === "application/pdf"
        ? {
            "application/pdf": [".pdf"],
            "application/msword": [".doc"],
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
              ".docx",
            ],
            "application/vnd.ms-excel": [".xls"],
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
              ".xlsx",
            ],
            "image/*": [".jpeg", ".jpg", ".png", ".webp"],
          }
        : typeof accept === "object"
          ? accept
          : undefined;

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: dropzoneAccept,
  });

  const HandlePicture = async (e) => {
    const fileUploaded = e;
    if (!fileUploaded) return;
    try {
      const cloudName =
        process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || "afrilocales";
      const uploadPreset =
        process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET || "svmprhvf";
      // auto/upload supports images and documents (PDF, etc.)
      const uploadUrl = `https://api.cloudinary.com/v1_1/${cloudName}/auto/upload`;

      const formData = new FormData();
      formData.append("file", fileUploaded);
      formData.append("upload_preset", uploadPreset);

      setLoading(true);
      const response = await fetch(uploadUrl, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      setLoading(false);
      if (!response.ok || !data?.secure_url) {
        return;
      }
      onChange(data.secure_url, fileUploaded, data);
    } catch (error) {
      setLoading(false);
    }
  };

  const Loader = () => {
    return (
      <Spinner size="sm" animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  };

  return (
    <div>
      <div>
        {LabelText && (
          <Form.Label className={labelClassName}>
            {LabelText}

            {required && <span className="text6">*</span>}
          </Form.Label>
        )}
      </div>
      <div {...getRootProps()}>
        <input {...getInputProps()} />
        {
          <div className="d-inline rounded  pointer">
            {isDragActive && <div className="">{bodyText}</div>}
            <div className="d-flex justify-content-start align-items-center">
              {bodyText}
              {loading && <Loader />}
            </div>
          </div>
        }
      </div>
      {errors?.map((error, i) => (
        <small className="text-danger mt-2" key={i}>
          {error}
        </small>
      ))}
    </div>
  );
};
